import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { jobConverter } from "../models/jobModel";
import { saveData } from "./jobSlice";

const getJobs = () => {
  return (dispatch) => {
    const unsubscribe = onSnapshot(
      collection(db, "cms/website/jobs").withConverter(jobConverter),
      (querySnapshot) => {
        const resources = [];
        querySnapshot.forEach((doc) => {
          const docData = doc.data();
          if (!docData.disabled) {
            resources.push({ ...docData, id: doc.id });
          }
        });
        dispatch(saveData(resources));
      }
    );
  };
};

export { getJobs };
